import { render } from "./LoginModal.vue?vue&type=template&id=feaafc50&bindings={\"isLoginOpen\":\"options\",\"email\":\"data\",\"password\":\"data\",\"isLoading\":\"data\",\"submit\":\"options\",\"close\":\"options\"}"
import script from "./LoginModal.vue?vue&type=script&lang=js"
export * from "./LoginModal.vue?vue&type=script&lang=js"
script.render = render

export default script